import { Spin } from 'antd';

import { MATCHING } from '@common/constants';
import { COMING_SOON_ICON_IMAGE } from '@common/utils';

import { AlertWithMetadata } from './interfaces/ProductMatchingSummary';

import './messageWithAlerts.scss';

type MessageWithAlertsProps = {
    children?: React.ReactNode;
    enableMatching?: MATCHING;
    isCalculatingAlerts?: boolean;
    alerts?: AlertWithMetadata[];
};

const emptyArray = [] satisfies string[];

export const MessageWithAlerts: React.FC<MessageWithAlertsProps> = ({
    children,
    enableMatching,
    isCalculatingAlerts,
    alerts = emptyArray,
}) => {
    return enableMatching === MATCHING.RICARDO ? (
        <>
            {isCalculatingAlerts && <Spin style={{ fontSize: 24 }} />}
            {!isCalculatingAlerts && (
                <>
                    <div className="alerts-container">
                        {alerts
                            .sort((a, b) => a.label.localeCompare(b.label))
                            .map((alert, index) => (
                                <div className="alerts-card" key={index}>
                                    <div className="alerts-card__icon">
                                        <img src={alert.imageUrl ?? COMING_SOON_ICON_IMAGE} />
                                    </div>
                                    <div className="alerts-card__label">{alert.label}</div>
                                </div>
                            ))}
                    </div>
                </>
            )}
        </>
    ) : (
        <div>{children} </div>
    );
};
